import React from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import style from './caravanWeight.scss';
import { calcWeight } from '../../../services/helper';

function CaravanWeight(props) {
    const { configuration } = props;

    return (
        <div className={style.weight}>
            <h2>{calcWeight(configuration)} KG <br /> {t`Gesamtgewicht`}</h2>
        </div>
    );
}

const mapStateToProps = state => ({
    configuration: state.configuration,
});

export default connect(mapStateToProps, null)(CaravanWeight);
